export const sizedcanvasHome = window.innerWidth <= 1000 ? 350 : 470;

export const isMovilResponsive = window.innerWidth <= 1000;
